import { Eyebrow, Reveal } from "@/components/Reveal";

export default function AboutStory() {
  return (
    <section id="story" data-testid="story-section" className="relative overflow-hidden py-24 sm:py-32">
      <div className="tartan-bg absolute inset-0 opacity-[0.07]" />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <div className="relative mx-auto max-w-md">
            <div className="absolute -inset-3 rotate-2 rounded-3xl border border-[#F0A829]/40" />
            <div className="clip-corner-sm relative -rotate-2 overflow-hidden rounded-2xl border border-white/10 transition-transform duration-700 ease-out hover:rotate-0">
              <img
                src="/assets/poster.jpg"
                alt="The Kilted Courier — click and collect delivery poster"
                data-testid="story-poster-image"
                className="w-full object-cover"
              />
            </div>
            <p className="font-mono-brand mt-6 text-center text-[10px] uppercase tracking-[0.3em] text-[#B9C4B4]">
              The original poster — yes, the kilt is real
            </p>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>Our story</Eyebrow>
            <h2 className="font-display mt-4 text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-[#F6F1E3] sm:text-6xl">
              A courier with<br />
              <span className="text-[#F0A829]">a bit of tartan</span>
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-7 max-w-2xl text-base leading-relaxed text-[#B9C4B4] sm:text-lg">
              The Kilted Courier started with a simple idea: getting things from
              Canberra to the Snowy Mountains shouldn&apos;t mean you have to take a day off work
              and a tank of fuel. So we put on the kilt, loaded up the van, and
              started running the route ourselves.
            </p>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#B9C4B4] sm:text-lg">
              Order and pay in the app, watch your parcel climb the mountain with
              free live tracking, and get proof of delivery the moment it lands.
              Same-day or next-day, depending on pickup availability — always
              delivered with a kilted smile.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 grid grid-cols-3 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10">
              {[
                { n: "01", t: "Order in the app", d: "Book & pay in minutes" },
                { n: "02", t: "We collect", d: "From any Canberra store" },
                { n: "03", t: "You track", d: "Peace of mind — free POD on arrival" },
              ].map((s) => (
                <div key={s.n} className="bg-[#0C1F17]/90 px-5 py-6" data-testid={`story-step-${s.n}`}>
                  <p className="font-display text-lg font-bold uppercase tracking-wide text-[#F6F1E3]">{s.t}</p>
                  <p className="mt-1 text-xs text-[#B9C4B4]">{s.d}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
